//Styles for the new user landing page
import styled from "styled-components";

export const NewUserContainer = styled.div`
    height: 85vh;
    display: flex;
    flex-flow: column nowrap;
    text-align: center;
`
export const NewHeader = styled.h2`
    color: #2CBBDB;
    margin: 5%;
`

export const CarouselImg = styled.img`
    width: 70vw !important;
    height: 55vh !important;
    margin: auto !important;
    border: 1px solid black;
`

export const NewText = styled.p`
    color: #2CBBDB;
    width: 60%;
    margin: 0 auto;
    padding-top: 1%;
    font-size: 1.62em
    
`



